module.exports = {
  BASE_URL: `${window.location.origin}/`,
  API_LOCATION: 'https://moritzgvt.de/',
  API_TYPE: {
    wp: 'wp-json/wp/v2/',
    custom: 'wp-json/custom/v1/',
    acf: 'wp-json/acf/v2/'
  }
}